var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 24.7C5.5 24.7 0 19.2 0 12.4C0 5.5 5.5 0 12.4 0C19.2 0 24.7 5.6 24.7 12.4C24.6 19.2 19.1 24.7 12.3 24.7ZM2.3 12.3C2.3 17.8 6.7 22.3 12.2 22.3C17.8 22.3 22.3 17.9 22.3 12.4C22.3 6.9 17.9 2.4 12.4 2.3C6.8 2.3 2.3 6.7 2.3 12.3Z",
    fill: "#9E2021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 8.80005C11.3998 7.60005 11.3998 6.50005 11.3998 5.30005C11.3998 4.70005 11.7998 4.30005 12.2998 4.30005C12.7998 4.30005 13.1998 4.70005 13.1998 5.30005C13.1998 7.20005 13.1998 9.20005 13.1998 11.1C13.1998 11.4 13.2998 11.5 13.4998 11.5C15.0998 11.5 16.6998 11.5 18.1998 11.5C18.9998 11.5 19.3998 12.2 19.0998 12.9C18.8998 13.2 18.6998 13.4 18.2998 13.4C16.2998 13.4 14.1998 13.4 12.1998 13.4C11.6998 13.4 11.2998 13 11.2998 12.4C11.3998 11.1 11.3998 9.90005 11.3998 8.80005Z",
    fill: "#9E2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempo);
export default __webpack_public_path__ + "static/media/tempo.4033bd82b56f95d4632ca4bbd4127369.svg";
export { ForwardRef as ReactComponent };